import { formatUserTime } from 'owa-datetime-formatters';
import { owaDate } from 'owa-datetime';

export interface ITimeListItem {
    key: number;
    text: string;
}

export const generateTimeList = (
    startMinutes: number,
    endMinutes: number,
    intervalMinutes: number
): ITimeListItem[] => {
    const generatedArray: ITimeListItem[] = [];
    for (let i = startMinutes; i <= endMinutes; i = i + intervalMinutes) {
        const time = owaDate('UTC', 0, 0, 0, 0, i);
        const formattedUserTime = formatUserTime(time);
        generatedArray.push({
            key: i,
            text: formattedUserTime,
        });
    }
    const isCyclic = endMinutes - startMinutes == 24 * 60;
    if (isCyclic) {
        generatedArray.pop();
    }
    return generatedArray;
};
